export default __webpack_public_path__ + "static/media/832.fa8dd547.gif";